import { Component } from '@angular/core';
import { StaticFields } from './staticFields';

@Component({
  selector: 'app-custom-status-bar',
  template: `
    <div *ngIf="filters.length > 0 && filters[0].filters[0]" class="ag-theme-balham ag-root-wrapper ag-layout-normal ag-ltr ag-status-bar" style="height: 30px;">
      <div class="grid">
        <div class="col" style="margin-top: -6px;">
          <span class="filters" *ngFor="let item of filters;let i = index ">
            <label style="font-size: large;">[</label>
            <span *ngIf="item.filters[0]?.filterType === 'set'">
              <label *ngIf="item.filters[0]?.values?.length > 0" style="background-color: #f1cead;">{{item.label}}</label>
              <label *ngIf="item.filters[0]?.values?.length < 6">=</label> 
              <label *ngIf="item.filters[0]?.values?.length < 6" style="background-color: #9bc59b">{{item.filters[0].values.join()}}</label>
              <label *ngIf="item.filters[0]?.values?.length > 5"> : </label> 
              <label data-toggle="tooltip" data-placement="top" title="{{item.filters[0]?.values}}" *ngIf="item.filters[0]?.values?.length > 5" style="background-color: #95b9cf;">{{item.filters[0]?.values?.length}}</label> 
            </span>
            <span *ngIf="item.filters[0]?.filterType === 'number'">
              <label style="background-color: #f1cead;">{{item.label}}</label>
              <label *ngIf="!item.filters[0].conditions" style="background-color: #9bc59b">{{convertOperatorToSymbol(item.filters[0].type)}}</label> 
              <label *ngIf="!item.filters[0].conditions" style="background-color: #95b9cf;" >{{item.filters[0].filter}}{{item.filters[0].filterTo ? '-'+item.filters[0].filterTo : ''}}</label>
              <label *ngIf="item.filters[0].conditions" style="background-color: #9bc59b">{{convertOperatorToSymbol(item.filters[0].conditions[0].type)}}</label> 
              <label *ngIf="item.filters[0].conditions" style="background-color: #95b9cf;" >{{item.filters[0].conditions[0].filter}}{{item.filters[0].conditions[0].filterTo ? '-'+item.filters[0].conditions[0].filterTo : ''}}</label>
              <label *ngIf="item.filters[0].conditions"> {{item.filters[0].operator}} </label> 
              <label *ngIf="item.filters[0].conditions" style="background-color: #9bc59b">{{convertOperatorToSymbol(item.filters[0].conditions[1].type)}}</label> 
              <label *ngIf="item.filters[0].conditions" style="background-color: #95b9cf;" >{{item.filters[0].conditions[1].filter}}</label>
            </span>
            <span *ngIf="!item.filters[0]?.filterType">
              <label style="background-color: #f1cead;">{{item.label}}</label>
              <label>=</label> 
              <label style="background-color:rgb(245, 244, 184)">BG_Color</label>
            </span>
            <span *ngIf="showAndColorFilter(item)">
              <label>AND</label>
              <label style="background-color:rgb(245, 244, 184)">BG_Color</label>
            </span>
            <label style="font-size: large;">]</label>
            <i class="pi pi-times" style="font-size: 0.8rem;cursor:pointer;" (click)="removeFilter(i)"></i>
            <label style="margin-left: 10px;" *ngIf="i < filters.length -1">AND</label>
          </span>
        </div>
        <i class="pi pi-times col-fixed" style="font-size: 1.7rem;cursor:pointer;" (click)="clearAll()"></i>
      </div>
    </div>
  `,
  styles: ['.ag-status-bar {line-height : 2 !important;}', '.filters {label {display: inline ; margin-right: 2px;padding:4px;font-size:13px;}}']
})
export class CustomStatusBarComponent {
  filters : any[] = [];
  colorFilter: any = [];
  currentFilters: any = [];
  gridApi: any;
  isPCMGrid: boolean;
  context: any;
  
  constructor(){}
  updateFilters(gridApi: any, isPCMGrid: boolean, context: any) {
    this.gridApi = gridApi;
    this.isPCMGrid = isPCMGrid;
    this.context = context;
    this.currentFilters = this.gridApi.getFilterModel();
    const filterCopy = JSON.parse(JSON.stringify(this.colorFilter));
    this.colorFilter.splice(0);
    this.filters.splice(0);
    if (this.isPCMGrid) {
      StaticFields.precodeScreenData.filters = this.gridApi.getFilterModel();
    }
    if (Object.keys(this.currentFilters).length > 0) {
      Object.keys(this.currentFilters).forEach(ele => {
        const field = this.capitalize(ele.includes('_') && ele.split("_").length > 1 ? ele : ele.split(/(?=[A-Z])/).length > 1 ? ele.split(/(?=[A-Z])/).join(' ') : ele);
        if (this.currentFilters[ele]?.filterModels) {
          this.currentFilters[ele]?.filterModels.forEach((f: any) => {
            if (f) {
              if (f.filterType)
                this.filters.push({ 'label': field, 'filters': [f] });
              const foundFilter = this.colorFilter.find((c: any) => c.name === field);
              if (foundFilter)
                foundFilter.count = 2;
              else
                this.colorFilter.push({ name: field, count: 1, filter: f, isColorFilter: !(f.filterType) });
            }
          });
          this.colorFilter.filter((cf: any) => cf.count === 1 && cf.isColorFilter).forEach((cf: any) => {
            this.filters.push({ 'label': cf.name, 'filters': [cf.filter] });
          });
        } else if (this.currentFilters[ele]?.filterType) {
          this.filters.push({ 'label': field, 'filters': [this.currentFilters[ele]] });
        }
      });
    }
    const updatedFilters: any = {};
    filterCopy.forEach((fc: any) => {
      const foundFilter = this.colorFilter.find((f: any) => f.name === fc.name);
      if (foundFilter && foundFilter.count === 1 && fc.count === 2) {
        
        Object.keys(this.currentFilters).forEach((ele : any) => {
          if (ele.toLowerCase() !== fc.name.replace(/\s/g, '').toLowerCase()) {
            updatedFilters[ele] = this.currentFilters[ele];
          }
        })
        this.filters.splice(this.filters.findIndex((f: any) => f.label === fc.name), 1);
      }
    });
    if (Object.keys(updatedFilters).length > 0) {
      this.gridApi.setFilterModel(updatedFilters);
      if (this.isPCMGrid) {
        StaticFields.precodeScreenData.filters = updatedFilters;
      }
    }
    if (this.isPCMGrid) {
      this.context.setHeight();
    }
  }

  showAndColorFilter(item: any): boolean {
    return this.colorFilter?.length > 0 ? this.colorFilter.find((c: any) => c.name === item.label).count === 2 : false;
  }

  convertOperatorToSymbol(operator: string) {
    switch (operator.toLowerCase().trim()) {
        case 'equals':
        case 'blank':
            return '=';
        case 'notequal': 
        case 'notblank':       
            return '≠';
        case 'lessthan':
            return '<';
        case 'greaterthan':
            return '>';
        case 'lessthanorequal':
            return '≤';
        case 'greaterthanorequal':
            return '≥';
        default:
            return ":";
    }
  }

  capitalize(s: string): string {
    return s && String(s[0]).toUpperCase() + String(s).slice(1);
  }

  removeFilter(index: number) {
    const updatedFilters: any = {};
    const field = (() => this.filters[index]['label'].charAt(0).toLowerCase() + this.filters[index]['label'].slice(1))();
    Object.keys(this.currentFilters).forEach((ele : any) => {
      if (ele != field.replace(/\s/g, '')) {
        updatedFilters[ele] = this.currentFilters[ele];
      }
    })
    this.filters.splice(index,1);
    this.gridApi.setFilterModel(updatedFilters);
    if (this.isPCMGrid) {
      StaticFields.precodeScreenData.filters = updatedFilters;
      this.context.setHeight();
    }    
  }
  clearAll() {
    this.gridApi.setFilterModel(null);
    this.filters.splice(0);
    if (this.isPCMGrid) {
      StaticFields.precodeScreenData.filters = null;
      this.context.setHeight();
    }
  }
}  

